import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { Component, OnInit } from '@angular/core';

import { ServicioGeneral } from 'src/app/_services/servicio-general.service';
import { environment } from 'src/environments/environment';
import { ClientLoaderService } from 'src/app/core/util/client-loader.service';

@Component({
  selector: 'app-preguntas-emvs',
  templateUrl: './preguntas-emvs.component.html',
  styleUrls: ['./preguntas-emvs.component.css']
})
export class PreguntasEmvsComponent extends UnsubscribeOnDestroy implements OnInit {

  API_URL: string = environment.API_URL;
  faQ: any = [];
  private readonly gmuFaqIcons = ['cronologia.svg', 'blogger.svg', 'cuenta-verificada.svg', 'proteger.svg'];

  constructor(
    private serviciogeneral: ServicioGeneral,
    public clientLoader: ClientLoaderService
  ) {
    super();
  }

  ngOnInit(): void {
    this.clientLoader.getClientName().then(clientName => {
      if (clientName === 'gmu') {
        this.loadStaticFaq();
      } else {
        this.getFaq();
      }
    });
  }

  private loadStaticFaq(): void {
    this.faQ = this.gmuFaqIcons.map((icono, index) => ({
      icono,
      titleKey: `HOME.FAQ.${index + 1}.TITLE`,
      descriptionKey: `HOME.FAQ.${index + 1}.DESCRIPTION`
    }));
  }

  getFaq() {
    return this.serviciogeneral.getFaq()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.faQ = (data['FAQ'] ?? []).map((faq: { id?: number; icono?: string }, index: number) => ({
          ...faq,
          titleKey: `HOME.FAQ.${faq.id ?? index + 1}.TITLE`,
          descriptionKey: `HOME.FAQ.${faq.id ?? index + 1}.DESCRIPTION`,
        }));
      });
  }
}
